"use client";
import { memo } from "react";
import { CrossIcon } from "./icons";
import { Button } from "./ui/button";
import { initialArtifactData, useArtifact } from "@/hooks/use-artifact";
import { useSelector, useDispatch } from "react-redux";
import {setActiveNavItem,setIsCodeView
} from "@/store/mainSlice";
import { toast } from 'sonner';


function PureArtifactCloseButton() {
  const { setArtifact } = useArtifact();
  const dispatch = useDispatch()
  const {isGeneratingWebsite} = useSelector((state)=>state.main)
  const closeButton = document.querySelector<HTMLElement>(
    ".custom-close-iframe"
  );

  if (closeButton) {
    closeButton.addEventListener("click", () => {
      document.body.classList.remove("hide-overflow"); // remove the class you added
    });
  }

  return (
    <Button
      id="closeHTMLEditor"
      data-testid="artifact-close-button"
      variant="outline"
      className=""
      onClick={() => {
        if(isGeneratingWebsite){
          
          toast.error("Please hold on—we’re setting up your page.", {
            style: { color: "red" }, // only text color
             position: "top-center",
            iconTheme: { primary: "red", secondary: "#fff" },
          });
          return;
          
        };

        dispatch(setIsCodeView(false))

        dispatch(setActiveNavItem("z-[40]"));
        setArtifact((currentArtifact) => {
          // If streaming, just hide it but reset other state too
          if (currentArtifact.status === "streaming") {
            return {
              ...initialArtifactData,
              isVisible: false, // hide
              status: "idle", // stop streaming
              content: "", // reset content
              htmlUrl: "", // reset html URL if exists
            };
          }

          // Normal close
          return { ...initialArtifactData, status: "idle" };
        });
      }}
    >
      <CrossIcon size={18} />
    </Button>
  );
}

export const ArtifactCloseButton = memo(PureArtifactCloseButton, () => true);
